import { render, staticRenderFns } from "./check-data.vue?vue&type=template&id=11218522&scoped=true"
import script from "./check-data.vue?vue&type=script&lang=js"
export * from "./check-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11218522",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11218522')) {
      api.createRecord('11218522', component.options)
    } else {
      api.reload('11218522', component.options)
    }
    module.hot.accept("./check-data.vue?vue&type=template&id=11218522&scoped=true", function () {
      api.rerender('11218522', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/correspondence/batch/check-data.vue"
export default component.exports